var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIMyPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00085 15.2097C12.4304 15.2097 15.2107 12.4295 15.2107 8.99987C15.2107 5.57028 12.4304 2.79004 9.00085 2.79004C5.57125 2.79004 2.79102 5.57028 2.79102 8.99987C2.79102 12.4295 5.57125 15.2097 9.00085 15.2097Z",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.0001 11.0412C10.1274 11.0412 11.0412 10.1274 11.0412 9.0001C11.0412 7.87282 10.1274 6.95898 9.0001 6.95898C7.87282 6.95898 6.95898 7.87282 6.95898 9.0001C6.95898 10.1274 7.87282 11.0412 9.0001 11.0412Z",
    fill: "#10141A",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2.7903V1",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.0003V15.21",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.209 9H16.9993",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9H2.7903",
    stroke: "#10141A",
    strokeWidth: 1.29732,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIMyPosition);
export default __webpack_public_path__ + "static/media/i_my_position.1a15d7f7e516a94d97d23a5449511dd9.svg";
export { ForwardRef as ReactComponent };